import React from "react";
import { Link } from "react-router-dom";
import menuIcon01 from "../images/menu_icon01.png";
import menuIcon02 from "../images/menu_icon02.png";
import menuIcon03 from "../images/menu_icon03.png";
import menuIcon04 from "../images/menu_icon04.png";
import menuIcon05 from "../images/menu_icon05.png";
import menuIcon06 from "../images/menu_icon06.png";
import MainHeader from "./MainHeader";

export default function MainMenu() {
    return (
        <div id="hamMenu">
            <div class="top-wrap">
                <MainHeader isOpenMenu={true} isShowTopPanel={true} isShowNotice={false} />
            </div>
            <div class="container">
                <div class="menu-list">
                    <Link class="menu-item-wrap" to="/fire-on/add/">
                        <div class="le-wrap">
                            <img class="menu-icon" src={menuIcon01} alt="" />
                            <p class="menu-title">소방대상물 추가</p>
                        </div>
                        <i class="x-icon arrow-icon"></i>
                    </Link>
                    <Link class="menu-item-wrap" to="/fire-on/edit/">
                        <div class="le-wrap">
                            <img class="menu-icon" src={menuIcon02} alt="" />
                            <p class="menu-title">
                                소방대상물 삭제 <span>(편집)</span>{" "}
                            </p>
                        </div>
                        <i class="x-icon arrow-icon"></i>
                    </Link>
                    <Link class="menu-item-wrap" to="/fire-on/fire-alarm-setting/sms/">
                        <div class="le-wrap">
                            <img class="menu-icon" src={menuIcon03} alt="" />
                            <p class="menu-title">화재경보 SMS 설정</p>
                        </div>
                        <i class="x-icon arrow-icon"></i>
                    </Link>
                    <Link class="menu-item-wrap" to="/fire-on/fire-alarm-setting/">
                        <div class="le-wrap">
                            <img class="menu-icon" src={menuIcon04} alt="" />
                            <p class="menu-title">화재경보음 On/Off</p>
                        </div>
                        <i class="x-icon arrow-icon"></i>
                    </Link>
                    <Link class="menu-item-wrap" to="/fire-on/user-access-management/">
                        <div class="le-wrap">
                            <img class="menu-icon" src={menuIcon06} alt="" />
                            <p class="menu-title">사용자 접속 관리</p>
                        </div>
                        <i class="x-icon arrow-icon"></i>
                    </Link>
                </div>
            </div>
        </div>
    );
}
